const SBMActivityXML =
    `<?xml version="1.0" encoding="utf-8"?>
<androidx.constraintlayout.widget.ConstraintLayout xmlns:android="http://schemas.android.com/apk/res/android"
    xmlns:app="http://schemas.android.com/apk/res-auto"
    xmlns:tools="http://schemas.android.com/tools"
    android:layout_width="match_parent"
    android:layout_height="match_parent"
    tools:context=".MainActivity">

    <androidx.recyclerview.widget.RecyclerView
        android:layout_width="match_parent"
        android:layout_height="wrap_content"
        tools:listitem="@layout/item_layout"
        android:id="@+id/recycler_view"
        app:layoutManager="androidx.recyclerview.widget.LinearLayoutManager"
        android:orientation="vertical"
        app:layout_constraintLeft_toLeftOf="parent"
        app:layout_constraintRight_toRightOf="parent"
        app:layout_constraintTop_toTopOf="parent" />
</androidx.constraintlayout.widget.ConstraintLayout>`

const item_layout =
    `<?xml version="1.0" encoding="utf-8"?>
<androidx.constraintlayout.widget.ConstraintLayout xmlns:android="http://schemas.android.com/apk/res/android"
    xmlns:app="http://schemas.android.com/apk/res-auto"
    android:layout_width="match_parent"
    android:layout_height="wrap_content"
    android:layout_margin="4dp"
    android:background="?attr/selectableItemBackground"
    android:elevation="6dp">

    <androidx.cardview.widget.CardView
        android:id="@+id/cardview"
        android:layout_width="0dp"
        android:layout_height="wrap_content"
        android:layout_alignParentEnd="true"
        app:cardCornerRadius="5dp"
        app:cardUseCompatPadding="true"
        app:layout_constraintBottom_toBottomOf="parent"
        app:layout_constraintEnd_toEndOf="parent"
        app:layout_constraintStart_toStartOf="parent"
        app:layout_constraintTop_toTopOf="parent">

        <LinearLayout
            android:id="@+id/layout_click"
            android:layout_width="match_parent"
            android:layout_height="wrap_content"
            app:layout_constraintEnd_toEndOf="parent"
            app:layout_constraintStart_toStartOf="parent"
            app:layout_constraintTop_toTopOf="parent">

            <TextView
                android:id="@+id/srNo"
                android:layout_width="wrap_content"
                android:layout_height="wrap_content"
                android:padding="8dp"
                android:text="sr No"
                android:textSize="16sp"
                android:textStyle="bold" />

            <TextView
                android:id="@+id/part_name"
                android:layout_width="0dp"
                android:layout_height="wrap_content"
                android:layout_weight="1"
                android:padding="8dp"
                android:text="enter the name"
                android:textSize="16sp"
                android:textStyle="bold" />

        </LinearLayout>
    </androidx.cardview.widget.CardView>

</androidx.constraintlayout.widget.ConstraintLayout>`

const item_model =
    `package com.example

class ItemModel(private var name:String) {

    fun setName(name: String) {
        this.name = name
    }
    fun getName():String{
        return name
    }
}`

const item_adapter =
    `package com.example

import android.view.LayoutInflater
import android.view.View
import android.view.ViewGroup
import android.widget.TextView
import androidx.recyclerview.widget.RecyclerView
import java.util.ArrayList

class ItemAdapter(private var itemList: ArrayList<ItemModel>) :
    RecyclerView.Adapter<ItemAdapter.ViewHolder>() {


    class ViewHolder(ItemView: View) : RecyclerView.ViewHolder(ItemView) {
        val srNo: TextView = itemView.findViewById(R.id.srNo)
        val nameTxt: TextView = itemView.findViewById(R.id.part_name)
   }

    override fun onCreateViewHolder(parent: ViewGroup, viewType: Int): ViewHolder {
        val view: View =
            LayoutInflater.from(parent.context).inflate(R.layout.item_layout, parent, false)
        return ViewHolder(view)
    }

    override fun onBindViewHolder(holder: ViewHolder, position: Int) {
        holder.srNo.text = (position + 1).toString()
        holder.nameTxt.text = itemList[position].getName()
    }

    override fun getItemCount(): Int {
        return itemList.size
    }
}`

const SBMActivityKIT =
    `package com.example


import android.annotation.SuppressLint
import android.os.Bundle
import android.view.Menu
import androidx.appcompat.app.AppCompatActivity
import androidx.appcompat.widget.SearchView
import androidx.recyclerview.widget.RecyclerView
import java.util.*
import kotlin.collections.ArrayList


class MainActivity : AppCompatActivity() {
    private lateinit var arrayList: ArrayList<ItemModel>
    private lateinit var adapter: ItemAdapter
    private lateinit var recyclerView: RecyclerView
    override fun onCreate(savedInstanceState: Bundle?) {
        super.onCreate(savedInstanceState)
        setContentView(R.layout.activity_main)

        recyclerView = findViewById(R.id.recycler_view)
        arrayList = ArrayList()
        arrayList.add(ItemModel("Meet"))
        arrayList.add(ItemModel("Ankit"))
        arrayList.add(ItemModel("Rushil"))
        arrayList.add(ItemModel("Abhishek"))
        arrayList.add(ItemModel("Modi"))
        arrayList.add(ItemModel("Ghree"))
        arrayList.add(ItemModel("Kirtan"))
        arrayList.add(ItemModel("Ankita"))
        arrayList.add(ItemModel("Soham"))
        arrayList.add(ItemModel("Ganesh"))
        arrayList.add(ItemModel("Dixit"))
        arrayList.add(ItemModel("Ankash"))
        arrayList.add(ItemModel("Parth"))
        arrayList.add(ItemModel("Pranav"))
        arrayList.add(ItemModel("Ankit Sir"))
        arrayList.add(ItemModel("Priya Mem"))
        arrayList.add(ItemModel("Jinal Mem"))
        arrayList.add(ItemModel("Bhumi"))
        arrayList.add(ItemModel("Nidhi"))
        arrayList.add(ItemModel("Hardik"))
        arrayList.add(ItemModel("Mayank"))
        arrayList.add(ItemModel("Kaushik"))
        arrayList.add(ItemModel("Rinku"))
        arrayList.add(ItemModel("Mom"))
        adapter = ItemAdapter(arrayList)

        recyclerView.adapter = adapter
    }

    override fun onCreateOptionsMenu(menu: Menu): Boolean {
        menuInflater.inflate(R.menu.search_menu, menu)
        val search = menu.findItem(R.id.app_bar_search)

        val searchView = search.actionView as SearchView
        searchView.maxWidth = android.R.attr.width
        searchView.queryHint = "Search"
        searchView.setOnQueryTextListener(object : SearchView.OnQueryTextListener {
            override fun onQueryTextSubmit(query: String?): Boolean {
                return false
            }

            @SuppressLint("NotifyDataSetChanged")
            override fun onQueryTextChange(newText: String?): Boolean {
                val checkItemModelArrayList: ArrayList<ItemModel> = ArrayList()

                for (i in arrayList) {
                    if (i.getName().lowercase(Locale.getDefault()).contains(
                            newText!!.lowercase(Locale.getDefault())
                        )
                    ) {
                        checkItemModelArrayList.add(i)
                    }
                }
                adapter = ItemAdapter(checkItemModelArrayList)

                recyclerView.adapter = adapter
                adapter.notifyDataSetChanged()
                return true
            }
        })

        return super.onCreateOptionsMenu(menu)
    }
}`

const SBMenuXML =
    `<?xml version="1.0" encoding="utf-8"?>
<menu xmlns:android="http://schemas.android.com/apk/res/android"
    xmlns:app="http://schemas.android.com/apk/res-auto">
    <item
        android:id="@+id/app_bar_search"
        android:icon="@drawable/ic_search_black_24dp"
        android:title="Search"
        app:showAsAction="ifRoom|withText"
        app:actionViewClass="androidx.appcompat.widget.SearchView"/>
</menu>`


module.exports = {
    SBMActivityXML: SBMActivityXML, SBMenuXML: SBMenuXML,
    item_layout: item_layout,
    item_model: item_model,
    item_adapter: item_adapter,
    SBMActivityKIT: SBMActivityKIT,
};
